(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["moo-complementary"] && !Shopify.designMode) return;
  try {
    (() => {
  const wire = (root) => {
    if (root.dataset.mooCompReady === '1') return;
    root.dataset.mooCompReady = '1';
    const track = root.querySelector('[data-moo-comp-track]');
    if (!track) return;
    const dots = [...root.querySelectorAll('[data-moo-comp-dot]')];
    const counter = root.querySelector('[data-moo-comp-count]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

    const sync = () => {
      const width = track.clientWidth || 1;
      const index = Math.round(track.scrollLeft / width);
      dots.forEach((dot, i) => dot.classList.toggle('is-on', i === index));
      if (counter && dots.length) counter.textContent = `${index + 1} / ${dots.length}`;
    };

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
      });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  };
  const init = () => document.querySelectorAll('[data-moo-comp]').forEach(wire);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

})();
